export const getAgreementsDealerOfficeState = (state) =>
  state.agreements.companyFilters.dealerOffice;
